export default "__VITE_ASSET__Dx_wvl_R__"